import React from 'react';

import classNames from 'classnames';

import { Button } from '@components/Button';

type Props = {
  submitBtnLabel?: string;
  cancelBtnLabel?: string;
  resetBtnLabel?: string;
  cancelUrl?: string;
  editBtnLabel?: string;
  removeBtnLabel?: string;
  viewBtnLabel?: string;
  isSubmitDisabled?: boolean;
  isRemoveDisabled?: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
  onReset?: () => void;
  onEdit?: () => void;
  onRemove?: () => void;
  onView?: () => void;
  wrapperClassNames?: string;
  isColumn?: boolean;
};

const ActionButtons: React.FC<Props> = ({
  submitBtnLabel,
  cancelBtnLabel,
  resetBtnLabel,
  cancelUrl,
  editBtnLabel,
  removeBtnLabel,
  viewBtnLabel,
  isSubmitDisabled = false,
  isRemoveDisabled = false,
  wrapperClassNames,
  onSubmit,
  onCancel,
  onReset,
  onEdit,
  onRemove,
  onView,
  isColumn = false,
}) => {
  return (
    <div
      className={
        wrapperClassNames || 'mt-15 flex flex-col w-full desktop:w-120'
      }
    >
      {onSubmit && (
        <Button
          dataTestId="save-btn"
          disabled={isSubmitDisabled}
          clickHandler={onSubmit}
          className={classNames('w-full', {
            'max-w-lg': !isColumn,
            'max-w-none': isColumn,
          })}
          type="submit"
        >
          {submitBtnLabel}
        </Button>
      )}
      {onReset && (
        <Button
          dataTestId="reset-btn"
          clickHandler={onReset}
          className={classNames('w-full mt-6', {
            'max-w-lg': !isColumn,
            'max-w-none': isColumn,
          })}
          secondary
          hasNoFocus
          type="reset"
        >
          {resetBtnLabel}
        </Button>
      )}
      {(onCancel || cancelUrl) && (
        <Button
          to={cancelUrl}
          clickHandler={onCancel}
          text
          className={classNames('w-full mt-6 focus:shadow-none', {
            'max-w-lg': !isColumn,
            'max-w-none': isColumn,
          })}
        >
          {cancelBtnLabel}
        </Button>
      )}
      {onEdit && (
        <Button
          dataTestId="edit-btn"
          clickHandler={onEdit}
          className={classNames('w-full', {
            'max-w-lg': !isColumn,
            'max-w-none': isColumn,
          })}
        >
          {editBtnLabel}
        </Button>
      )}
      {onRemove && (
        <Button
          dataTestId="remove-btn"
          to={cancelUrl}
          clickHandler={onRemove}
          text
          disabled={isRemoveDisabled}
          className={classNames('w-full mt-6 focus:shadow-none', {
            'max-w-lg': !isColumn,
            'max-w-none': isColumn,
          })}
        >
          {removeBtnLabel}
        </Button>
      )}
      {onView && (
        <Button
          dataTestId="view-btn"
          clickHandler={onView}
          className={classNames('w-full', {
            'max-w-lg': !isColumn,
            'max-w-none': isColumn,
          })}
        >
          {viewBtnLabel}
        </Button>
      )}
    </div>
  );
};

export default ActionButtons;
